module.exports = __webpack_public_path__ + "static/media/ujamn.686aa74a.m4a";